export interface SecurityServer {
  _id: string;
  name: string;
  specifics: {
    endpointId: string;
    ip: string;
  };
}

export interface GetShareableSecurityServersResponse {
  records: Array<SecurityServer>;
  total: number;
}

export interface AssignedSecurityServer {
  _id: string;
  name: string;
  ip: string;
}

export interface AssignedSecurityServersOnEntity {
  _id: string;
  name: string;
  securityServers: Array<AssignedSecurityServer>;
}

export interface GetAssignedSecurityServersForEntitiesResponse {
  records: Array<AssignedSecurityServersOnEntity>;
  total: number;
}

export enum AssignedSecurityServerColumn {
  TARGET_NAME = 'name',
  SERVER_INFO = 'serverInfo',
}

export interface AssignedSecurityServerItem {
  [AssignedSecurityServerColumn.TARGET_NAME]: string;
  [AssignedSecurityServerColumn.SERVER_INFO]: string;
}

export interface FutureAssignedSecurityServerTableItem {
  id: string;
  name: string;
}
